import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const iconButtonVariants = cva(
  "inline-flex items-center justify-center shrink-0 rounded-lg transition-all duration-fast focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-daydra-accent focus-visible:ring-offset-1 focus-visible:ring-offset-daydra-bg disabled:pointer-events-none disabled:opacity-disabled",
  {
    variants: {
      variant: {
        default: "text-daydra-dim hover:text-daydra-text hover:bg-daydra-raised",
        ghost: "text-daydra-muted hover:text-daydra-dim hover:bg-daydra-raised",
        accent: "text-daydra-accent hover:text-daydra-accent-hover hover:bg-daydra-accent-ghost",
        danger: "text-daydra-muted hover:text-daydra-error hover:bg-daydra-error-dim",
      },
      size: {
        sm: "h-7 w-7",
        default: "h-8 w-8",
        lg: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface IconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof iconButtonVariants> {}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={cn(iconButtonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);

IconButton.displayName = "IconButton";
